import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { MainHTTPService } from '../main-http/main-http.service';
import { MainModel } from 'src/app/models/auth/_models/main-model';
import { ActionResult } from 'src/app/models/auth/_models/action-result';
import { MessagesService } from '../common/messages.service';


@Injectable({
  providedIn: 'root'
})
export class MainService {
  isLoadingSubject: BehaviorSubject<boolean>;
  main: BehaviorSubject<MainModel[]> = new BehaviorSubject<MainModel[]>([]);
  constructor(private mainHttpService: MainHTTPService, private messagesService:MessagesService,) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
  }


  loadMenu(code: string): Observable<MainModel[]> {
   
    this.isLoadingSubject.next(true);
    return this.mainHttpService.get(code).pipe(
      catchError(err => of(this.messagesService.error("Error conectando con el proveedor de menú"))),
      map((resp: ActionResult<MainModel[]>) => {     
        return resp.result;
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  loadMenuFilter(code: string): Observable<MainModel[]> {
    this.isLoadingSubject.next(true);
  
    return this.mainHttpService.getFilter(code).pipe(
      catchError(err => {
        this.messagesService.error("Error conectando con el proveedor de menú");
        return of({ result: [] } as ActionResult<MainModel[]>);
      }),
      map((resp: ActionResult<MainModel[]>) => {
        const result = resp.result || [];
  
        if (!result.length) {
          this.messagesService.warning(`Menú no encontrado: ${code}`);
        }
  
        this.main.next(result); // Si este Subject es necesario
  
        return result;
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }
  
}
